import React from 'react'
import { PrimaryButton } from 'components/core/Buttons'
import styled from 'styled-components'
import { StatusContainer } from './common'
import Link from 'next/link'

const NewArtContainer = styled(StatusContainer)`
  width: 312px;
  padding-top: 8px;
  justify-content: center;
  align-items: flex-start;
  padding-bottom: 16px;

  box-shadow: 0px 1.49px 4.0375px rgba(255, 255, 255, 0.2), inset 0px 8px 12px rgba(0, 0, 0, 0.25);
`

const DraftImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #ffffff;
  left: 0;
  right: 0;
  top: 0;
  position: absolute;
`

function ContinueDraftStatusCell() {
  return (
    <NewArtContainer>
      <Link
        passHref
        href={{
          pathname: '/draw',
        }}
      >
        <PrimaryButton
          as={'a'}
          buttonSize="small"
          style={{ borderRadius: 30, width: '90%', zIndex: 10 }}
          type="button"
        >
          Start Drawing
        </PrimaryButton>
      </Link>
      {/* <DraftImage src="/images/dashboard/draft.png" /> */}
      <DraftImage src="/images/start-drawing-gobbler.png" />
    </NewArtContainer>
  )
}

export default ContinueDraftStatusCell
